import { KText } from '@/ui-library/components/text';
import { Flex, Box, Button } from '@chakra-ui/react';

export const FilterFooter = ({
  selected = [],
  onClear = () => {},
  onApply = () => {},
  ...props
}) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="right"
      borderTopWidth="1px"
      borderColor="light.border"
      mx="-16px"
      px="16px"
      pt="16px"
      flex="0 0 auto"
    >
      {selected.length > 0 && (
        <KText flex="1" size="sm-medium" color="secondary-700">
          <KText as="span" size="sm-medium" mr="xs" color="secondary-900">
            {selected.length}
          </KText>
          Selected
        </KText>
      )}
      <Box mr="8px">
        <Button variant="secondary" onClick={onClear}>
          Clear
        </Button>
      </Box>
      <Box>
        <Button variant="primary" {...props} onClick={onApply}>
          Apply filter
        </Button>
      </Box>
    </Flex>
  );
};
